import { createSlice } from "@reduxjs/toolkit";
import { fetchArchiveServicesTeacherDisabilityData,updateMergeDataToActualData } from "../thunks/archiveServicesThunk";

const archiveServicesTeacherDisabilitySlice = createSlice({
  name: "archiveServicesTeacherDisability",
  initialState: {
    data: [{
            "regionType": "",
            "regionCode": "",
            "yearId": 11,
            "location": "India",
            
    }],
    isLoading:true,
    isError:false,
    error:null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArchiveServicesTeacherDisabilityData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchArchiveServicesTeacherDisabilityData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchArchiveServicesTeacherDisabilityData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })

      .addCase(updateMergeDataToActualData.fulfilled, (state, action) => {
        state.data.data = action.payload;
        state.isLoading = false;
      })
  },
});

export default archiveServicesTeacherDisabilitySlice.reducer;